// @flow

import * as urls from '../urls';
import * as request from 'app/utils/request';
import {gt} from 'app/utils/i18n';
import {DEFAULT_PAGE_SIZE} from 'app/utils/constants';

import type {NotificationsFetchParamsType, NotificationType} from './types';

import type {ResponseType} from 'app/utils/redux_v2';
import {limitRequests} from 'app/utils/redux';

import {type NotificationModelChangeMessageType} from 'app/subscriptions/types';

export type NotificationsAction =
  | ReceiveNotificationsStatsActionType
  | RequestNotificationsActionType
  | ReceiveNotificationsListActionType;

/* receive notifications stats */
export const receiveNotificationsStats = (
  data: NotificationModelChangeMessageType
): ReceiveNotificationsStatsActionType => ({
  type: RECEIVE_NOTIFICATIONS_STATS,
  data,
});
export const RECEIVE_NOTIFICATIONS_STATS = 'RECEIVE_NOTIFICATIONS_STATS';

type ReceiveNotificationsStatsActionType = {
  +type: 'RECEIVE_NOTIFICATIONS_STATS',
  data: NotificationModelChangeMessageType,
};

export const REQUEST_NOTIFICATIONS = 'REQUEST_NOTIFICATIONS';

type RequestNotificationsActionType = {
  +type: 'REQUEST_NOTIFICATIONS',
  currentFilters: NotificationsFetchParamsType,
};

export const RECEIVE_NOTIFICATIONS_LIST = 'RECEIVE_NOTIFICATIONS_LIST';

type ReceiveNotificationsListActionType = {
  +type: 'RECEIVE_NOTIFICATIONS_LIST',
  query: NotificationsFetchParamsType,
  response: ResponseType<NotificationType>,
};

export const receiveNotifications = (
  query: NotificationsFetchParamsType,
  response: ResponseType<NotificationType>
): ReceiveNotificationsListActionType => ({
  type: RECEIVE_NOTIFICATIONS_LIST,
  query,
  response,
});

export const convertOptionsToFetchParams = (
  opts: $Shape<NotificationsFetchParamsType>
): NotificationsFetchParamsType => ({
  page: opts.page || '1',
  page_size: opts.page_size || DEFAULT_PAGE_SIZE,
  target_content_type: opts.target_content_type,
  target_object_id: opts.target_object_id,
  web_visible: opts.web_visible != null ? opts.web_visible : true,
  is_all: opts.is_all,
});

export const fetchNotificationsList = limitRequests(
  (opts?: $Shape<NotificationsFetchParamsType> = {}) =>
    (dispatch: SimpleDispatch) => {
      const query = convertOptionsToFetchParams(opts);

      return request
        .get(urls.NOTIFICATIONS_API, query)
        .then(
          (response) => dispatch(receiveNotifications(query, response)),
          request.createErrorHandler(
            gt('Could not fetch notifications.'),
            dispatch
          )
        );
    }
);

export const markAllAsRead = () => (dispatch: FuncDispatch) => {
  return request
    .postJson(urls.NOTIFICATIONS_MARK_READ)
    .then(() => dispatch(fetchNotificationsList()))
    .catch(
      request.createErrorHandler(
        gt('Could not mark notifications as read.'),
        dispatch
      )
    );
};
